export default "__VITE_ASSET__5536599d__"